const EVENTLIST = {

    SCREEN_REPAIR_ROUTE: "Screen Repair Route",
};

export default EVENTLIST;
